'use client'

// lib files
import { useHasMounted } from '@/lib/hooks';
import { usePersonalizedResource } from '@/lib/hooks/usePersonalizedResource';
import { myListViewingHistory } from '@/lib/resources/my-list-viewing-history';

// components
import LinkButton from '@/components/Button/LinkButton';
import LoadingSpinner from '@/components/LoadingSpinner/LoadingSpinner';
import MyListViewingHistoryGrid from '@/components/MyList/MyListViewingHistory/MyListViewingHistoryGrid';
import SignInButton from '@/components/Navigation/SignInButton';

// styles
import styles from './MyListViewingHistory.module.scss';

const MyListViewingHistory = () => {
  const history = usePersonalizedResource(myListViewingHistory);
  const hasMounted = useHasMounted();

  if (!hasMounted) return null;

  let content = null;

  switch (history.status) {
    case 'ready':
      content = <MyListViewingHistoryGrid videos={history.items} />;
      break;
    case 'loading':
      content = <LoadingSpinner text="Loading Your List..." />;
      break;
    case 'idle':
    case 'empty':
    case 'error':
      content = (
        <div className={styles.my_list_viewing_history_user_prompt}>
          <h2>Videos you&rsquo;ve watched will appear here.</h2>
          <LinkButton href="/shows/">
            Browse PBS Shows
          </LinkButton>
        </div>
      );
      break;
    case 'needsSignIn':
      content = (
        <div className={styles.my_list_viewing_history_user_prompt}>
          <h2>Sign in to see videos you&rsquo;ve watched</h2>
          <SignInButton>
            Sign In to Access
          </SignInButton>
        </div>
      );
      break;
  }

  return (
    <div className={styles.my_list_viewing_history}>
     {content}
    </div>
  );
};

export default MyListViewingHistory;
